import { render, staticRenderFns } from "./OrderHistoryContainer.vue?vue&type=template&id=bd468df2&"
import script from "./OrderHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports